<template>
  <div id="app" :key="appKey">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data(){
        return{
            appKey:1
        }
    },
    watch:{
        '$route'(to, from){
            this.appKey = new Date().getTime();
        }
    },
  }
</script>

<style>
  #app {
  background-color:#F3F5F6
    
  }
</style>



// WEBPACK FOOTER //
// src/App.vue